import React from 'react';
import { motion } from 'framer-motion';
import slider1 from '../../../assets/images/physical_theropy/helpingChildrenOne.jpg';
import slider4 from '../../../assets/images/physical_theropy/helpingChildrenTwo.jpg';
import slider5 from '../../../assets/images/physical_theropy/helpingChildrenThree.jpg';
import slider2 from '../../../assets/images/physical_theropy/helpingChildrenFour.jpg';
import slider6 from '../../../assets/images/physical_theropy/baby_jally.png';
import slider3 from '../../../assets/images/physical_theropy/slider_baby.png';
import GradientButton from '../../../components/atoms/GradientButton';
import GradientOutlineButton from '../../../components/atoms/GradientOutlineButton';
import CrossFadeImageSlider from '../../../components/molecules/CrossFadeImageSlider';
const images = [
  {
    src: slider1,
    alt: 'Child climbing in Wasilla physical therapy session',
  },
  {
    src: slider2,
    alt: 'Physical therapy stretching exercise in Wasilla, AK',
  },
  {
    src: slider3,
    alt: 'Physical therapy strength training for child in Wasilla',
  },
  {
    src: slider4,
    alt: 'Physical therapy strength training for child in Wasilla',
  },
  {
    src: slider5,
    alt: 'Physical therapy strength training for child in Wasilla',
  },
  {
    src: slider6,
    alt: 'Physical therapy strength training for child in Wasilla',
  },
];

function PhysicalTherapyMoment() {
  return (
    <div className="w-full flex flex-col justify-between gap-4 sm:gap-10 max-w-[1200px] mx-auto px-4 md:px-10 py-10 md:py-20 relative z-10">
      <div>
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.9, ease: 'easeOut' }}
          viewport={{ once: true, amount: 0.5 }}
        >
          <h4 className="text-[36px] sm:text-[42px] md:text-[52px] 2xl:text-[58px] 2xl:leading-[54px] text-[#7B54A2] font-bold leading-[40px] lg:leading-[50px] md:mr-4">
            Pediatric Physical Therapy <br /> helps children thrive <br />
            through movement.
          </h4>
        </motion.div>
      </div>
      <div className="flex flex-col lg:flex-row justify-between w-full gap-4 sm:gap-10 xl:gap-32">
        <div className="flex-1 flex flex-col items-start justify-between gap-4 sm:gap-6 lg:gap-8 font-custom text-lg md:text-xl 2xl:text-2xl text-secondary">
          <h2 className="text-[#7B54A2] text-[24px] sm:text-[26px] md:text-[28px] font-bold leading-8 sm:leading-10 ">
            Here at Guidepost, our Pediatric Physical Therapists help kids move
            more effectively, gain strength, and improve coordination so they
            can explore their environment, learn, and do all the things they
            love to do!
          </h2>
          <p>
            Pediatric physical therapy focuses on helping children develop and
            improve their motor skills, balance, strength, endurance, agility,
            mobility, and coordination. Skilled physical therapy services are
            delivered by trained therapists who specialize in working with
            children. Through play-based activities and exercises, therapists
            create a fun and engaging environment where children can work on
            specific goals to enhance their physical abilities.
          </p>
          <p>
            PT plays a vital role in addressing various conditions and
            challenges that can impact a child's physical development
          </p>
        </div>
        <div className="flex-1 flex justify-center overflow-hidden relative">
          <CrossFadeImageSlider
            width="w-[90vw] md:w-[700px] 2xl:w-[500px] "
            height="h-[600px] 2xl:h-[670px]"
            images={images}
            // rounded="rounded-2xl"
          />
        </div>
      </div>
      <div className="flex flex-col lg:flex-row justify-between w-full gap-4 sm:gap-10 xl:gap-32">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-5 md:gap-4">
          <GradientOutlineButton
            text="Meet Our Therapists"
            width="lg:w-[200px] w-full py-[6px] px-[6px] "
            navigateTo={'/our-team'}
          />
          <GradientButton
            text="Schedule an Evaluation"
            width="lg:w-[200px] w-full py-[6px] px-[6px] "
            navigateTo={'/contact'}
          />
          <a
            href={require('../../../assets/documents/pt_artical.pdf')}
            target="_blank"
            rel="noreferrer"
            className="w-full lg:w-[200px]"
          >
            <GradientOutlineButton
              text="What is PT PDF"
              width="lg:w-[200px] w-full py-[6px] px-[6px] "
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default PhysicalTherapyMoment;
